import { initializeApp } from "firebase/app";
// Analytics intentionally disabled until consent banner ships — see issue #37.
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBsJZCBvrH7B59X8Q7g4d4ctrMxVVqEYyg",
  authDomain: "rslighthouse-website.firebaseapp.com",
  projectId: "rslighthouse-website",
  storageBucket: "rslighthouse-website.firebasestorage.app",
  messagingSenderId: "9894808278",
  appId: "1:9894808278:web:5da49cfad0a66c48545777",
  measurementId: "G-PCD9DM42G6"
};

const app = initializeApp(firebaseConfig);

// export const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);

export default app;